/* eslint-disable @typescript-eslint/no-explicit-any */

type EventsMap = {
  [event: string]: any
}

export interface DefaultEvents extends EventsMap {
  [event: string]: (...args: any) => void
}

export interface EventEmitter<Events extends EventsMap = DefaultEvents> {
  emit<K extends keyof Events>(
    this: this,
    event: K,
    ...args: Parameters<Events[K]>
  ): void

  events: Partial<{ [E in keyof Events]: Events[E][] }>
  on<K extends keyof Events>(
    this: this,
    event: K,
    callback: Events[K],
  ): () => void
}

export type DefaultEmitter = EventEmitter

export const createEvents = <
  Events extends EventsMap = DefaultEvents,
>(): EventEmitter<Events> => ({
  events: {},
  emit(event, ...args) {
    const callbacks = this.events[event] || []
    for (let index = 0, { length } = callbacks; index < length; index++) {
      callbacks[index](...args)
    }
  },
  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [callback]
    } else {
      this.events[event]?.push(callback)
    }

    return () => {
      this.events[event] = this.events[event]?.filter(
        index => callback !== index,
      )
    }
  },
})
